import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from "react";

const theme = createTheme();

export default function joingroup(){
    return(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <main>
            <Box
          sx={{
            bgcolor: 'background.paper',
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="sm">
            <Typography
              component="h2"
              variant="h3"
              align="center"
              color="text.primary"
              gutterBottom
              style={{fontWeight:"bold"}}
            >
              Exclusive Community
            </Typography>
            <Typography variant="h6"  color="text.secondary" paragraph>
              Join Our Supportive Community that always has your Back
            </Typography>
            <Stack
              sx={{ pt: 4 }}
              direction="row"
              spacing={2}
              justifyContent="center"
            >
              <Button variant="contained" href="https://chat.whatsapp.com/FAjPzCH1kTTKS6aPOBNZb0">Join us on Whatsapp</Button>
              <Button variant="contained" href="https://discord.gg/hDAyavK9Rr">Join us on Discord</Button>
            </Stack>
          </Container>
        </Box>
            </main>
        </ThemeProvider>
    )
};